import type { SubmissionsStatus } from "@profile-service-types/index.ts";
import type { UseMutationOptions } from "@tanstack/vue-query";
import { useMutation, useQueryClient } from "@tanstack/vue-query";
import { TODO_SUBMISSION_QUERY_KEY_PREFIX } from "@/components/MyStudents/Submissions/composables/useSubmissionReviewData";
import profileService from "@/services/profile.js";

export interface UpdateSubmissionFeedbackVariables {
  submissionId: string;
  status?: SubmissionsStatus;
  feedback?: object;
}

export const useUpdateSubmissionFeedback = (
  useMutationOptions?: UseMutationOptions<unknown, Error, UpdateSubmissionFeedbackVariables>,
) => {
  const queryClient = useQueryClient();

  return useMutation<unknown, Error, UpdateSubmissionFeedbackVariables>({
    mutationFn: async ({ submissionId, status, feedback }) => {
      const response = await profileService.updateSubmissionFeedback(submissionId, { status, feedback });
      return response?.data?.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [TODO_SUBMISSION_QUERY_KEY_PREFIX] });
    },
    ...useMutationOptions,
  });
};
